import { PiCaretDownDuotone, PiCaretRightDuotone } from "react-icons/pi";

export default function MekiAboutPage() {
    return (
        <div className='min-h-screen'>
            <div className='font-display w-full flex flex-col min-h-screen' 
                style={{
                    backgroundImage: 'url(/assets/images/background/pattern-opacity.png)',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center top',
                }}
            >
                <div className="w-full flex flex-col min-h-screen relative overflow-hidden rounded-3xl">
                    <div
                        className='w-full h-full absolute top-0 left-0'
                        style={{
                            backgroundImage: 'url(/assets/images/meki_content_6.jpg)',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center top',
                        }}
                    />

                    <div className="w-full h-full absolute top-0 left-0 bg-black bg-opacity-30 flex flex-col items-center justify-center">
                        <div className="text-center mx-4 sm:mx-4 md:mx-10 lg:mx-20 xl:mx-20 2xl:mx-20 mt-10 sm:mt-10 md:mt-18 lg:mt-20 xl:mt-52 2xl:mt-52">
                            <div className="font-semibold text-yellow-400 text-4xl sm:text-4xl md:text-7xl lg:text-8xl xl:text-8xl 2xl:text-8xl mb-4">
                                Ismerd meg Mekis irodánk csapatát!
                            </div>
                        </div>

                        <div className="group flex flex-col items-center mt-20 cursor-pointer transition-transform duration-200 transform hover:scale-110 text-yellow-400 hover:text-lime-500"
                            onClick={() => document.getElementById('below-meki-section').scrollIntoView({ behavior: 'smooth' })}
                        >
                            <div className="text-white text-base sm:text-base md:text-3xl lg:text-3xl xl:text-3xl 2xl:text-3xl">
                                Tovább
                            </div>
                            <PiCaretDownDuotone className="size-24 mt-[-24px]"/>
                        </div>
                    </div>
                </div>

                <div className="relative text-center mx-4 sm:mx-4 md:mx-10 lg:mx-20 xl:mx-20 2xl:mx-20 mt-12">
                    <div id="below-meki-section" className="font-semibold text-lime-500 text-3xl sm:text-3xl md:text-5xl lg:text-6xl xl:text-6xl 2xl:text-6xl mb-4">
                        A diák az első, a csapatunk a második
                    </div>
                    <div className="w-full text-white text-xs sm:text-xs md:text-base lg:text-xl xl:text-lg 2xl:text-lg my-12">
                        Számunkra a Mekis diákmunka szervezése nem csak munka, hanem kihívásokkal teli élmény, amivel a diákoknak segíthetünk életük alakításában. Arra 
                        törekszünk, hogy kérdéseitekre és problémáitokra mielőbb megoldásokat találjunk. A Mekis munka pörgőssége pedig az irodánkban is érezhető. Valaki 
                        mindig jön-megy, intézkedik, egyeztet, telefonál.
                    </div>
                </div>

                <div className="w-full flex justify-center items-center">
                    <img
                        src="/assets/images/background/mi_mekisek_1.jpg"
                        alt="Background Picture"
                        className="w-full h-auto object-contain rounded-xl shadow-3xl"
                    />
                </div>

                <div className="relative text-center mx-4 sm:mx-4 md:mx-10 lg:mx-20 xl:mx-20 2xl:mx-20 my-12">
                    <div className="w-full text-white text-xs sm:text-xs md:text-base lg:text-xl xl:text-lg 2xl:text-lg mb-6">
                        „Nagyon sok diákkal kerülünk kapcsolatba, rengeteg pozitív élmény ér. Mindig van egy beszélgetés, egy felvett diák, egy beléptetés, egy megoldott 
                        feladat, egy elégedett étteremvezető, egy kiutalt jutalom, ami után az ember sóhajt egy boldogat, hogy nah, ezért is éri meg!”
                        <br/>
                        <br/>
                        Egyszerűen energiával tölt fel minket, ha jó érzéssel és elégedetten távoztok tőlünk.
                    </div>
                </div>

                <div className="w-full flex justify-center items-center">
                    <img
                        src="/assets/images/background/mi_mekisek_2.jpg"
                        alt="Background Picture"
                        className="w-full h-auto object-contain rounded-xl shadow-3xl"
                    />
                </div>

                <div className="relative text-center mx-4 sm:mx-4 md:mx-10 lg:mx-20 xl:mx-20 2xl:mx-20 my-12">
                    <div className="text-white text-xs sm:text-xs md:text-base lg:text-xl xl:text-lg 2xl:text-lg 
                                    mx-4 sm:mx-4 md:mx-10 lg:mx-20 xl:mx-24 2xl:mx-24 my-6 sm:my-6 md:my-6 lg:my-6 xl:my-6 2xl:my-6">
                        Folyamatosan kihívásokkal nézünk szembe, így a munkánk sosem unalmas, és tudjuk, hogy a csapatunk hozzáállásával, a megoldások keresésével 
                        minden elénk vagy a diákjaink elé gördülő akadályt meg tudunk oldani. A Fürge Diák Mekis csapata valójában ugyanolyan baráti társaság, mint egy Meki 
                        étterem csapata. Minden nehézségben osztozunk, és minden jó hírnek együtt örülünk. Egy második otthon, ahol örömmel töltjük el az időt, mert tudjuk, 
                        hogy jót teszünk, segítünk, és közben jól is érezhetjük magunkat.
                    </div>

                    <div className="font-semibold text-red-600 text-xl sm:text-xl md:text-2xl lg:text-3xl xl:text-3xl 2xl:text-3xl my-12">
                        Ha te is egy ilyen csapat része lennél a Meki kötelékében, akkor kattints!
                    </div>

                    <button
                        className="p-4 font-semibold text-white gradient-green text-xs sm:text-xs md:text-2xl lg:text-2xl xl:text-xl 2xl:text-xl 
                                    shadow-2xl rounded-lg transition duration-200 hover:ring-8 ring-white/20 hover:scale-105"
                    >
                        Jelentkezem
                    </button>
                </div>

                <div className="relative text-center mx-4 sm:mx-4 md:mx-10 lg:mx-20 xl:mx-20 2xl:mx-20 my-4 sm:my-4 md:my-4 lg:my-4 xl:my-6 2xl:my-6">
                    <div className="font-semibold text-lime-500 text-3xl sm:text-3xl md:text-5xl lg:text-6xl xl:text-6xl 2xl:text-6xl mb-4">
                        A Mekis munkáról
                    </div>
                    <div className="text-white text-xs sm:text-xs md:text-base lg:text-xl xl:text-lg 2xl:text-lg mx-4 sm:mx-4 md:mx-10 lg:mx-20 xl:mx-24 2xl:mx-24 my-6 sm:my-6 md:my-6 lg:my-6 xl:my-8 2xl:my-8">
                        A Mekiben a csapatmunka az első, és tudnod kell, hogy soha nem vagy egyedül. Mind a Meki mentor programja, mind a Fürge Diák Mekis csapata ott áll 
                        mellett, ha kérdésed adódik vagy segítségre van szükséged. Az étteremben folyamatos támogatással tanulod meg az egyes munkafolyamatokat, és 
                        rövid idő alatt magabiztosan mozogsz majd az egész étteremben.
                        <br/>
                        <br/>
                        A Mekis diákmunka pörgős. Nincs idő lustálkodásra, de szükség van az önállóságra. A csapata csak úgy tudja kiszolgálni a vendégeket, ha mindenki 
                        felelősséggel végzi el a rá bízott feladatokat.
                        <br/>
                        <br/>
                        És bár diákmunkát vállalsz, ugyanolyan Mekis leszel, mint bárki más. A Meki nem tesz különbséget diák és nem diák között. Felnőttként tekintenek rád, 
                        és az elvárások is eszerint alakulnak.
                        <br/>
                        <br/>
                        Érdekel a kihívás? Ismerd meg diákmunka ajánlatainkat!
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-4 justify-center items-center md:items-center lg:items-center xl:items-start gap-12 mx-4 sm:mx-4 md:mx-10 lg:mx-20 xl:mx-16 2xl:mx-16 my-16 sm:my-16 md:my-18 lg:my-20 xl:my-24 2xl:my-24">
                        <div className="flex flex-col w-full h-72 sm:h-72 md:h-96 lg:h-96 xl:h-96 2xl:h-96 gradient-gray rounded-2xl 
                                        shadow-2xl overflow-hidden transition duration-200 border-2 border-red-600 hover:border-0 ring-8 ring-yellow-400 hover:ring-lime-500 hover:scale-105 group">
                            <div className="relative z-10 w-full h-52 bg-cover bg-center rounded-xl overflow-hiddens" 
                                style={{ backgroundImage: 'url(/assets/images/meki_job_area_1.jpg)' }}>
                                <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-30 flex flex-col justify-end text-start p-4 text-white rounded-xl">
                                    <h3 className="text-lg sm:text-lg md:text-xl lg:text-xl font-semibold text-yellow-400 group-hover:text-lime-500 mb-1">Éttermi munkatárs</h3>
                                    <div className="flex flex-row justify-between items-center">
                                        <p className="text-sm sm:text-sm md:text-base lg:text-base">Kattints a részletekért!</p>
                                        <PiCaretRightDuotone className="text-4xl text-red-600 group-hover:text-lime-500"/>
                                    </div>
                                </div>
                            </div>
                            <div className="p-4 text-center gradient-gray">
                                <p className="text-white text-xs sm:text-xs md:text-sm lg:text-sm xl:text-sm 2xl:text-sm">
                                    Munkatársaink a Meki arcai is egyben. 
                                    Van, hogy a kasszában köszöntik a 
                                    vendégeket, és van, amikor a legjobb 
                                    szendvicseket készítik el számukra.
                                </p>
                            </div>
                        </div>

                        <div className="flex flex-col w-full h-72 sm:h-72 md:h-96 lg:h-96 xl:h-96 2xl:h-96 gradient-gray rounded-2xl 
                                        shadow-2xl overflow-hidden transition duration-200 border-2 border-red-600 hover:border-0 ring-8 ring-yellow-400 hover:ring-lime-500 hover:scale-105 group">
                            <div className="relative z-10 w-full h-52 bg-cover bg-center rounded-xl overflow-hidden" 
                                style={{ backgroundImage: 'url(/assets/images/meki_job_area_2.jpg)' }}>
                                <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-30 flex flex-col justify-end text-start p-4 text-white rounded-xl">
                                    <h3 className="text-lg sm:text-lg md:text-xl lg:text-xl font-semibold text-yellow-400 group-hover:text-lime-500 mb-1">Vendégélmény manager</h3>
                                    <div className="flex flex-row justify-between items-center">
                                        <p className="text-sm sm:text-sm md:text-base lg:text-base">Kattints a részletekért!</p>
                                        <PiCaretRightDuotone className="text-4xl text-red-600 group-hover:text-lime-500"/> 
                                    </div>
                                </div>
                            </div>
                            <div className="p-4 text-center gradient-gray">
                                <p className="text-white text-xs sm:text-xs md:text-sm lg:text-sm xl:text-sm 2xl:text-sm">
                                    Segítség a vendégnek. A Vendégélmény 
                                    manager segít a kioszkokon való 
                                    rendelésben, szükség esetén segít az 
                                    ételek kiválasztásában, és felügyeli, 
                                    hogy a vendégtérben minden rendben 
                                    legyen. 
                                </p>
                            </div>
                        </div>

                        <div className="flex flex-col w-full h-72 sm:h-72 md:h-96 lg:h-96 xl:h-96 2xl:h-96 gradient-gray rounded-2xl 
                                        shadow-2xl overflow-hidden transition duration-200 border-2 border-red-600 hover:border-0 ring-8 ring-yellow-400 hover:ring-lime-500 hover:scale-105 group">
                            <div className="relative z-10 w-full h-52 bg-cover bg-center rounded-xl overflow-hidden" 
                                style={{ backgroundImage: 'url(/assets/images/meki_job_area_3.jpg)' }}>
                                <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-30 flex flex-col justify-end text-start p-4 text-white rounded-xl">
                                    <h3 className="text-lg sm:text-lg md:text-xl lg:text-xl font-semibold text-yellow-400 group-hover:text-lime-500 mb-1">McCafé munkatárs / Barista</h3>
                                    <div className="flex flex-row justify-between items-center">
                                        <p className="text-sm sm:text-sm md:text-base lg:text-base">Kattints a részletekért!</p>
                                        <PiCaretRightDuotone className="text-4xl text-red-600 group-hover:text-lime-500"/>    
                                    </div>
                                </div>
                            </div>
                            <div className="p-4 text-center gradient">
                                <p className="text-white text-xs sm:text-xs md:text-sm lg:text-sm xl:text-sm 2xl:text-sm">
                                    Kávé rajongók terepe, ahol a Barista 
                                    készíti el a McCafé kávéit, szendvicseit, 
                                    és felszolgálja a süteményeket.
                                </p>
                            </div>
                        </div>

                        <div className="flex flex-col w-full h-72 sm:h-72 md:h-96 lg:h-96 xl:h-96 2xl:h-96 gradient-gray rounded-2xl 
                                        shadow-2xl overflow-hidden transition duration-200 border-2 border-red-600 hover:border-0 ring-8 ring-yellow-400 hover:ring-lime-500 hover:scale-105 group">
                            <div className="relative z-10 w-full h-52 bg-cover bg-center rounded-xl overflow-hidden" 
                                style={{ backgroundImage: 'url(/assets/images/meki_job_area_4.jpg)' }}>
                                <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-30 flex flex-col justify-end text-start p-4 text-white rounded-xl">
                                    <h3 className="text-lg sm:text-lg md:text-xl lg:text-xl font-semibold text-yellow-400 group-hover:text-lime-500 mb-1">Hostess</h3>
                                    <div className="flex flex-row justify-between items-center">
                                        <p className="text-sm sm:text-sm md:text-base lg:text-base">Kattints a részletekért!</p>
                                        <PiCaretRightDuotone className="text-4xl text-red-600 group-hover:text-lime-500"/> 
                                    </div>
                                </div>
                            </div>
                            <div className="p-4 text-center gradient-gray">
                                <p className="text-white text-xs sm:text-xs md:text-sm lg:text-sm xl:text-sm 2xl:text-sm">
                                    Az első, hogy a vendég jól érezze magát, 
                                    amikor betér a Mekibe. A Vendégtér 
                                    koordinátor ezért felel. Beszélget velük, 
                                    szervezi a szülinapi partikat, 
                                    szóróajándékot oszt, és kezeli az ad hoc 
                                    panaszokat.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}